export const PinSpaceService = Symbol('PinSpaceService');
